module.exports = __webpack_public_path__ + "static/img/cjfw-partners.9c347c57.png";